import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { clusterApiUrl } from '@solana/web3.js'
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base'
import {
  getPhantomWallet,
  getSolletWallet,
  getSolletExtensionWallet,
  getSolflareWallet,
  getLedgerWallet,
  getSolongWallet,
  getMathWallet,
  getSafePalWallet,
} from '@solana/wallet-adapter-wallets'
import {
  ConnectionProvider,
  WalletProvider,
} from '@solana/wallet-adapter-react'
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui'

import App from './App'
import reportWebVitals from './reportWebVitals'

import '@solana/wallet-adapter-react-ui/styles.css'
import './index.css'

const network = WalletAdapterNetwork.Mainnet
const endpoint = clusterApiUrl(network)
const wallets = [
  getPhantomWallet(),
  getSolletExtensionWallet({ network }),
  getSolletWallet({ network }),
  getSolflareWallet(),
  getLedgerWallet(),
  getSolongWallet(),
  getMathWallet(),
  getSafePalWallet(),
]

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ConnectionProvider endpoint={endpoint}>
        <WalletProvider wallets={wallets}>
          <WalletModalProvider>
            <App />
          </WalletModalProvider>
        </WalletProvider>
      </ConnectionProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
